/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import SecureLS from "secure-ls";
import state from "./state";
var ls = new SecureLS({ isCompression: false });

Vue.use(Vuex);

import moduleAuth from "./auth/index";
import moduleRoom from "./room/index";
import moduleFeedback from "./feedback/index";
import moduleEmail from "./email/index";
import cms from "./cms";
import menu from "./CmsMenu/Index";
import brandProfile from "./brandProfile";
export default new Vuex.Store({
  modules: {
    auth: moduleAuth,
    room: moduleRoom,
    feedback: moduleFeedback,
    email: moduleEmail,
    cms: cms,
    menu,
    brandProfile,
    state,
  },
  strict: process.env.NODE_ENV !== "production",
  plugins: [
    createPersistedState({
      storage: {
        getItem: (key) => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: (key) => ls.remove(key),
      },
    }),
  ],
});

// window.ls = ls;

// export { ls };
